// extracted by mini-css-extract-plugin
export default {"pad":"styles_pad__K8k6+","canvas":"styles_canvas__0pj8n","footer":"styles_footer__Ls8iI"};